module.exports = __webpack_public_path__ + "img/bgblack.cf0d106c.png";